export const signupCompletedHtml = `
<h1 id="je-bent-klaar">Je bent klaar</h1>
<p>Er is zojuist een e-mail verstuurd met daarin je API key. Bewaar de API key goed, want deze heb je nodig om in te kunnen loggen op je <a href="/account">account</a>.</p>
<p>In de <a href="/docs">documentatie</a> kun je lezen hoe je Postcode API implementeert. Op naar je eerste API call!</p>

`
